module.exports = __webpack_public_path__ + "img/phone.5fb570f8.svg";